<template>
  <div v-if="info" v-html="info"></div>
  <div class="row" v-else>
    <div class="col-6">
      <h4>{{ trans('More Details') }}</h4>
      {{ trans('Would you like more information about the vehicle or about the action?') }}
      <button class="btn btn-primary btn-modern" @click.prevent="loadInfo">
        <template v-if="loading">
          <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </template>
        <template v-else>
          <i class="fas fa-lock"></i>
          {{ trans('Unlock Content For Free') }}
        </template>
      </button>
    </div>
  </div>
</template>

<script>
  import { apiClient } from '../api';

  export default {
    name: 'LockedInfo',

    props: {
      infoRoute: {
        type: String,
        required: true,
      }
    },

    data() {
      return {
        loading: false,
        info: '',
      }
    },

    methods: {
      loadInfo() {
        if (this.loading) {
          return;
        }

        this.loading = true;

        apiClient
          .get(this.infoRoute)
          .then(response => {
            this.info = response.data;
          })
          .catch(error => {
          })
          .finally(() => {
            this.loading = false;
          })
      },
    }
  }
</script>
